(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    if(!window.rzSpecialistContactValidationPatch){window.rzSpecialistContactValidationPatch=true;document.addEventListener('click',function(event){var submit=event.target&&event.target.closest&&event.target.closest('.rz-specialist-contact-modal__submit');if(!submit)return;var form=submit.closest('.rz-specialist-contact-modal__form');var error=form&&form.querySelector('[data-rz-validation-error]');if(form&&error&&!form.checkValidity()){error.hidden=false;}})}document.querySelectorAll('.rz-specialist-contact__button--request .rz-specialist-contact__icon').forEach(function(icon){icon.remove();});
  } catch(e) { console.error(e); }
})();

})();
